import { CCardGroup, CCol, CContainer, CFormSelect, CModal, CModalBody, CRow } from '@coreui/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { createNowPaymentURL, enToPersianChar } from '../../../../components/helper'
import { ArrowLeftBackSVG, ArrowRigthtBackSVG } from '../../../../components/IconSvg'
import PayPageContent from './payPageContent'
import './style.scss'

const PayPage = ({
  selected,
  setSelect,
  price,
  currency,
  user,
  invoiceId,
  status,
  showModal,
  setShowModal,
  duration,
  pageType,
  setInvoiceId,
  purchasedPackage,
  invoiceDetail
}) => {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const location = useLocation()

  const nowPaymentsAction = () => {
    var a = document.createElement('a')
    a.setAttribute('id', 'nowP')
    a.setAttribute('target', '_blank')
    a.href = createNowPaymentURL({
      invoiceId: invoiceId,
      orderId: `WHMCS-${invoiceId}`,
      paymentAmount: price, // invoiceDetail?.extraInfo.total,
      customerEmail: user?.email,
      customerName: user?.firstName,
      paymentCurrency: 'USD',
    })
    document.body.appendChild(a)
    document.getElementById('nowP').click()
    document.body.removeChild(a)
  }

  const closePage = () => {
    if (pageType) {
      setShowModal(false)
      setInvoiceId('')
    } else {
      navigate('/Packages', { state: { from: 'auth' } })
    }
  }

  const closeModal = () => {
    setShowModal(false)
    setInvoiceId('')
  }



  return (
    <div>
      <div className='set-main-form-wizard-container d-flex flex-row justify-content-center pay-page mt-2'  >
        <div className='set-form-wizard-container set-container payment-container' style={{ marginTop: '0' }} >
          <div className='d-flex flex-row justify-content-start'>
            <div className='d-flex flex-row justify-content-start'>
              <div className='skip-holder d-flex flex-row justify-content-around' onClick={() => {

                if (location.state.from === 'panel') {
                  navigate("/invoice", { state: { ...location.state } })
                } else {
                  navigate("/packages", { state: { ...location.state, from: "auth" } })
                }
              }}>
                {i18n.language === 'fa' ? <>
                  <span className='d-flex flex-row justify-content-center'> <ArrowLeftBackSVG /></span>
                  <span >{t('BACK')}</span>
                </> : <>
                  <span >{t('BACK')}</span>
                  <span className='d-flex flex-row justify-content-center'> <ArrowRigthtBackSVG /></span></>}

              </div>
            </div>
          </div>
          <div className='set-container-form payment'>
            <div className="wizard-form">
              {/* <p className=' d-flex flex-row justify-content-start'>{t('PAYMENT_PRICE_OF_SERVICE')}</p> */}
              {invoiceDetail && <PayPageContent
                selected={selected}
                setSelect={setSelect}
                price={price}
                currency={currency}
                user={user}
                invoiceId={invoiceId}
                status={status}
                showModal={showModal}
                setShowModal={setShowModal}
                duration={duration}
                nowPaymentsAction={nowPaymentsAction}
                closePage={closePage}
                purchasedPackage={purchasedPackage}
                invoiceDetail={invoiceDetail}
              />}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="set-container-form payment">
        <div className="wizard-form">
          <PayPageContent
            selected={selected}
            setSelect={setSelect}
            price={price}
            currency={currency}
            user={user}
            invoiceId={invoiceId}
            status={status}
            showModal={showModal}
            setShowModal={setShowModal}
            duration={duration}
            nowPaymentsAction={nowPaymentsAction}
            closePage={closePage}
            purchasedPackage={purchasedPackage}
          />
        </div>
      </div> */}
    </div>



  )
}
export default PayPage
